export interface SavedArticle {
    // articleId is the article ID, and the value is the unix timestamp of when the article was saved in custom objects.
    [articleId: string]: number
}

export interface SavedArticlesData {
    SavedArticles: SavedArticle
    object_id: string
    object_modified_on: string // Format: 2024-01-09T06:08:13.998Z
}

export class SavedArticlesStore {
    private static _instance: SavedArticlesStore
    private savedArticlesData: SavedArticlesData

    public static getInstance(): SavedArticlesStore {
        return this._instance || (this._instance = new this())
    }

    constructor() {
        this.savedArticlesData = {
            SavedArticles: {},
            object_id: '',
            object_modified_on: ''
        }
    }

    public add(
        article_id: string,
        object_id: string,
        object_modified_on: string,
        saved_on: number
    ): void {
        const articles = {
            ...this.savedArticlesData.SavedArticles,
            [article_id]: saved_on
        }
        this.savedArticlesData = {
            SavedArticles: articles,
            object_id: object_id,
            object_modified_on: object_modified_on
        }
    }

    public delete(article_id: string, object_modified_on: string): void {
        const articles = { ...this.savedArticlesData.SavedArticles }
        delete articles[article_id]
        this.savedArticlesData = {
            SavedArticles: articles,
            object_id: this.savedArticlesData.object_id,
            object_modified_on: object_modified_on
        }
    }

    public update(savedArticles: SavedArticlesData): void {
        this.savedArticlesData = savedArticles
    }

    public objectId(): string {
        return this.savedArticlesData.object_id
    }

    public modifiedDate(): string {
        return this.savedArticlesData.object_modified_on
    }

    public savedArticles(): SavedArticle {
        return this.savedArticlesData.SavedArticles
    }

    public savedArticlesNumber(): number {
        return Object.keys(this.savedArticles()).length
    }
}
